import container from '../container/container';
import jumpFactory from '../jump/jump';
import binder from '../utils/binder';
import gsap from 'gsap';

export interface PublicVarsInterface {
	cssId: {
		faqItemCls: string;
		faqItemInvokeCls: string;
		faqItemActiveCls: string;
		faqDisplayAllBtnCls: string;
		faqItemCotentCls: string;
		faqDisplayAllBtnActiveCls: string;
	},
}

interface PrivateVarsInterface {
	name: string;
	displayAllBtnHtml: HTMLElement | null;
	isAnimating: Record<number, boolean>;
	isAnimatingAll: boolean
}

const faqService = function (id: number) {

	let publicVars: PublicVarsInterface;

	let privateVars: PrivateVarsInterface;

	const methods = {
		init: (options: PublicVarsInterface) => {
			publicVars = options;

			privateVars = {
				name: 'faqService(' + id + ')',
				displayAllBtnHtml: document.querySelector(publicVars.cssId.faqDisplayAllBtnCls),
				isAnimating: {},
				isAnimatingAll: false
			}

			methods.bind();
			methods.startup();
		},

		startup: function () {

		},
		bind: function () {
			container.msg(privateVars.name, 'module started');

			binder.bindToAll('click', publicVars.cssId.faqItemInvokeCls, function(e) {
				const element = e.currentTarget as HTMLElement;
				methods.toggleItem(element);
			});

			if(privateVars.displayAllBtnHtml) {
				privateVars.displayAllBtnHtml.addEventListener('click', function () {
					methods.toggleAll();
				})
			}
		},
		toggleAll: function() {

			if(privateVars.isAnimatingAll) {
				return;
			}

			privateVars.isAnimatingAll = true;

			const isActive = privateVars.displayAllBtnHtml?.classList.contains(publicVars.cssId.faqDisplayAllBtnActiveCls.substring(1));

			const faqItemsList = document.querySelectorAll(publicVars.cssId.faqItemCls) as NodeListOf<HTMLElement>;

			if(!isActive) {
				faqItemsList.forEach(item => item.classList.add(publicVars.cssId.faqItemActiveCls.substring(1)));
				privateVars.displayAllBtnHtml?.classList.add(publicVars.cssId.faqDisplayAllBtnActiveCls.substring(1));

				gsap.to(publicVars.cssId.faqItemCotentCls, {
					opacity: 1,
					duration: 0.5,
					ease: 'power1.inOut',
					height: 'auto',
					onComplete: () => {
						privateVars.isAnimatingAll = false;
					}
				});
			} else {
				faqItemsList.forEach(item => item.classList.remove(publicVars.cssId.faqItemActiveCls.substring(1)));
				privateVars.displayAllBtnHtml?.classList.remove(publicVars.cssId.faqDisplayAllBtnActiveCls.substring(1));

				gsap.to(publicVars.cssId.faqItemCotentCls, {
					opacity: 0,
					duration: 0.2,
					ease: 'power1.out',
					height: 0,
					onComplete: () => {
						privateVars.isAnimatingAll = false;
					}
				});
			}

		},
		toggleItem: function(element: HTMLElement) {
			const parent = element.closest(publicVars.cssId.faqItemCls) as HTMLElement | null;
			const content = parent?.querySelector(publicVars.cssId.faqItemCotentCls) as HTMLElement | null;

			if(parent === null || content === null) {
				return;
			}

			const elementId = parent.dataset.id;

			if(!elementId || privateVars.isAnimating[+elementId] || privateVars.isAnimatingAll) {
				return;
			}

			privateVars.isAnimating[+elementId] = true;

			const isActive = parent.classList.contains(publicVars.cssId.faqItemActiveCls.substring(1));

			parent.classList.toggle(publicVars.cssId.faqItemActiveCls.substring(1));

			if(!isActive) {
				content.style.height = 'auto';

				const contentOffsetHeight = content.offsetHeight;

				content.style.height = '0';

				gsap.to(content, {
					opacity: 1,
					duration: 0.5,
					ease: 'power1.inOut',
					height: contentOffsetHeight,
					onComplete: () => {
						content.style.height = 'auto';
						privateVars.isAnimating[+elementId] = false;
					}
				});
			} else {
				gsap.to(content, {
					opacity: 0,
					duration: 0.2,
					ease: 'power1.out',
					height: 0,
					onComplete: () => {
						content.removeAttribute('style');
						privateVars.isAnimating[+elementId] = false;
					}
				});
			}
		}
	}

	return {
		init: function (options: PublicVarsInterface) {
			methods.init(options);
		}
	}
}

const factory = {
	objId: 0,

	create: function () {
		factory.objId++;

		return faqService(factory.objId);
	}
};

export default {
	create: factory.create
};